import { render, staticRenderFns } from "./existencia-en-stock.vue?vue&type=template&id=fb682772&scoped=true"
import script from "./existencia-en-stock.vue?vue&type=script&lang=js"
export * from "./existencia-en-stock.vue?vue&type=script&lang=js"
import style0 from "./existencia-en-stock.vue?vue&type=style&index=0&id=fb682772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb682772",
  null
  
)

export default component.exports